import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Translate, I18n } from 'react-redux-i18n';
import { needsAuth } from '../utils/authHoc';

import { receiveSubscribition } from '../../actions/user';
import { addError } from '../../actions/utils';
import request from 'superagent';

import './Shop.jsx.scss';
import PhoneInput from './PhoneInput';

class Promocode extends React.Component {
  state = {
    promocodeKey: '',
    phone: '',
    phoneValid: true,
    success: false,
    promocode: null
  };

  handlePromocode = e => {
    const value = e.target.value;
    this.setState({ promocodeKey: value });
  };

  checkPromocode = () => {
    const { promocodeKey } = this.state;
    request
      .post(`/promocode/${promocodeKey.trim()}`)
      .end((err, { body: { promocode } }) => {
        if (promocode) {
          this.setState({ promocode }, () => {
            if (promocode.plan.startsWith('on-your-own')) {
              this.activatePromocode();
            }
          });
        } else {
          this.props.dispatch(
            addError(I18n.t('promocode.promocodeNotFound', { promocodeKey }))
          );
        }
      });
  };

  activatePromocode = () => {
    const { promocodeKey, phone, phoneValid } = this.state;
    if (phoneValid) {
      request
        .post(`/promocode/activate/${promocodeKey.trim()}`)
        .send({ phone })
        .end((err, { body }) => {
          if (err) {
            this.props.dispatch(addError(body));
          } else {
            this.setState({ success: true });
            this.props.dispatch(receiveSubscribition(body.subs));
          }
        });
    }
  };

  handlePhone = (phone, phoneValid) => {
    this.setState({ phone, phoneValid });
  };

  resetPromocode = () => {
    this.setState({ promocodeKey: '', promocode: null, success: false });
  };

  render() {
    return (
      <div className="container-fluid new-style shop-cart">
        {!this.state.promocode ||
        (!this.state.success &&
          this.state.promocode.plan.startsWith('on-your-own')) ? (
          <div className="row cart-block centered">
            <div className="col-xs-12 form-group">
              <h3 className="sub-title" style={{ textAlign: 'left' }}>
                <Translate value="promocode.promocodeActivate" />
              </h3>
            </div>

            <div className="col-xs-12 col-sm-6 form-group">
              <input
                style={{ marginTop: '2em', marginBottom: '4em' }}
                type="text"
                className="form-control"
                placeholder={I18n.t('promocode.promocode')}
                value={this.state.promocodeKey}
                onChange={this.handlePromocode}
              />
            </div>

            <div className="col-xs-12 form-group">
              <button
                className="btn btn-flat btn-flat-green btn-flat-rounded"
                style={{ marginLeft: 0 }}
                disabled={this.state.promocodeKey === ''}
                onClick={this.checkPromocode}
              >
                {I18n.t('promocode.activateButton')}
              </button>
            </div>

            <div className="col-xs-12">
              <Link className="btn btn-link text-muted" to="/i">
                <Translate value="promocode.backToCoursesButton" />
              </Link>
            </div>
          </div>
        ) : !this.state.success ? (
          <div className="row cart-block centered">
            <div className="col-xs-12 form-group">
              <h3 className="sub-title" style={{ textAlign: 'left' }}>
                {I18n.t('promocode.promocodeActivate')}
              </h3>
              {I18n.t('promocode.setPhoneNumber')}
            </div>

            <div
              className="col-xs-12"
              style={{
                marginTop: '2em',
                marginBottom: '4em',
                textAlign: 'left'
              }}
            >
              {this.props.user && (
                <PhoneInput
                  phone={this.props.user.phone}
                  highlight={this.state.phoneValid}
                  callback={this.handlePhone}
                  hideLabel={true}
                />
              )}
            </div>

            <div className="col-xs-12 form-group">
              <button
                className="btn btn-flat btn-flat-green btn-flat-rounded"
                style={{ marginLeft: 0 }}
                disabled={!this.state.phoneValid}
                onClick={this.activatePromocode}
              >
                {I18n.t('promocode.confirmButton')}
              </button>
            </div>

            <div className="col-xs-12">
              <Link className="btn btn-link text-muted" to="/i">
                <Translate value="promocode.backToCoursesButton" />
              </Link>
            </div>
          </div>
        ) : (
          <div className="row cart-block centered">
            <div className="col-xs-12 form-group">
              <h3 className="sub-title" style={{ textAlign: 'left' }}>
                {I18n.t('promocode.promocodeIsActivate')}
              </h3>
              <div style={{ marginTop: '2em', marginBottom: '5em' }}>
                {this.state.promocode.plan.startsWith('on-your-own') ? (
                  <Translate
                    value="promocode.selfStudyPromocodeIsActivate"
                    promocodeKey={this.state.promocodeKey}
                  />
                ) : (
                  <Translate
                    value="promocode.withTeacherPromocodeIsActivate"
                    promocodeKey={this.state.promocodeKey}
                  />
                )}
              </div>
            </div>

            <div className="col-xs-12 form-group">
              <Link
                className="btn btn-flat btn-flat-green btn-flat-rounded"
                style={{ marginLeft: 0 }}
                to="/i"
              >
                <Translate value="promocode.backToCoursesButton" />
              </Link>
            </div>

            <div className="col-xs-12">
              <button
                className="btn btn-link text-muted"
                onClick={this.resetPromocode}
              >
                {I18n.t('promocode.activateNewPromocode')}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: { user }
  } = state;
  return { user };
}

export default compose(
  needsAuth,
  connect(mapStateToProps)
)(Promocode);
